module.exports = __webpack_public_path__ + "img/1608885124208.f6d4ae8f.png";